import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';
import { APP_BASE_HREF } from '@angular/common';
import { APP_HOME_ROUTE } from '~shared/constants';

@Injectable({
  providedIn: 'root'
})
export class CanImpersonateGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly homepageNavigatorService: HomepageNavigatorService,
    @Inject(APP_BASE_HREF) private baseHref: string) {
  }

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const { _switch_user, _switch_user_token } = next.queryParams;
    const shouldActivate = Boolean(_switch_user && _switch_user_token);
    if (!shouldActivate) {
      window.location.href =
        `/${this.baseHref.replace(new RegExp('\/', 'g'), '')}/${APP_HOME_ROUTE}`;
    }

    return shouldActivate;
  }
}
